export default __webpack_public_path__ + "static/business-91ec2e849a17f555fcca1ff312ef1bd5.png";